import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastMessage {
	message: string;
	type: 'success' | 'error' | 'warning';
}

@Injectable({ providedIn: 'root' })
export class ToastService {
	private toastSubject = new Subject<ToastMessage | null>();
	private timeoutId: ReturnType<typeof setTimeout> | null = null;

	readonly toast$ = this.toastSubject.asObservable();

	success(message: string): void {
		this.show(message, 'success');
	}

	error(message: string): void {
		this.show(message, 'error');
	}

	warning(message: string): void {
		this.show(message, 'warning');
	}

	dismiss(): void {
		if (this.timeoutId) {
			clearTimeout(this.timeoutId);
			this.timeoutId = null;
		}
		this.toastSubject.next(null);
	}

	private show(message: string, type: ToastMessage['type']): void {
		// Clear any existing toast
		if (this.timeoutId) {
			clearTimeout(this.timeoutId);
		}

		// Show new toast
		this.toastSubject.next({ message, type });

		// Auto-dismiss after 2000ms (matching legacy)
		this.timeoutId = setTimeout(() => {
			this.toastSubject.next(null);
			this.timeoutId = null;
		}, 2000);
	}
}
